module.exports = "/assets/9aa89696be7da8b249e2ee2622a111e9.png";